import { z } from 'zod';

import pgIntervalSchema from 'validationSchemas/pgInterval';

export const FormSchema = z.object({
  min_age_to_register: pgIntervalSchema.nullable(),
  max_age_to_register: pgIntervalSchema.nullable(),
  min_age_at_first_period: pgIntervalSchema.nullable(),
  max_age_at_first_period: pgIntervalSchema.nullable(),
  require_permit_to_register: z.boolean(),
});

export type FormInputValues = z.input<typeof FormSchema>;
export type FormOutputValues = z.output<typeof FormSchema>;
